export const breakpoints = {
  px: {
    mobile: 480,
    tablet: 768,
    laptop: 992,
    desktop: 1024,
    largeDesktop: 1440,
  },
};

// To use media queries follow this pattern
// @media ${theme.mq.min/max[#] {
//    Styles Here
// }
export const mq = {
  min: {
    mobile: `only screen and (min-width: ${breakpoints.px.mobile}px)`,
    tablet: `only screen and (min-width: ${breakpoints.px.tablet}px)`,
    laptop: `only screen and (min-width: ${breakpoints.px.laptop}px)`,
    desktop: `only screen and (min-width: ${breakpoints.px.desktop}px)`,
    largeDesktop: `only screen and (min-width: ${breakpoints.px.largeDesktop}px)`,
  },
  max: {
    mobile: `only screen and (max-width: ${breakpoints.px.mobile}px)`,
    tablet: `only screen and (max-width: ${breakpoints.px.tablet}px)`,
    laptop: `only screen and (max-width: ${breakpoints.px.laptop}px)`,
    desktop: `only screen and (max-width: ${breakpoints.px.desktop}px)`,
    largeDesktop: `only screen and (max-width: ${breakpoints.px.largeDesktop}px)`,
  },
};
